export const AMAZON_SHOP_URL = "https://www.amazon.com/s?me=A27SOL74AZ50QZ&marketplaceID=ATVPDKIKX0DER";

export const GIVE_BACK_URL = "https://buy.stripe.com/6oUdR96Ex1nl1VG8FZ5Ne04";

export const GIVE_BACK_TEXT =
  "If you already saw our film, enjoyed it and wish to support independent queer cinema, then please consider giving back. This way, you can support the film and our future projects!";
